import { render, staticRenderFns } from "./winners-v2.page.vue?vue&type=template&id=51965410&scoped=true"
import script from "./winners-v2.page.vue?vue&type=script&lang=js"
export * from "./winners-v2.page.vue?vue&type=script&lang=js"
import style0 from "./winners-v2.page.vue?vue&type=style&index=0&id=51965410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51965410",
  null
  
)

export default component.exports